import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "60",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "30",
      cy: "30",
      r: "30",
      fill: "#FFFFFE"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#303030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M15.858 29.999h28.284m0 0L31.414 17.27m12.728 12.728L31.414 42.726"
    }, null, -1)
  ]))]))
}
export default { render: render }